<template>
	<div >
		<img :src="mainImgStr" class="proImg">
		<div class="exampleArea">
			<div class="arrowArea">
				<img src="../assets/images/leftArrow.png" class="leftArrow"  @click="leftImgClick()"/>
			</div>
			<div id="exampleScroll">
			<div class="exampleImgs">
				<img :src="item" v-for="(item,index) in imgList" class="exampleImg" 
				:class="selectedIdx == index ? 'active' : ''" @click="changeImg(item,index)"/>  
			</div>
			</div>
			<div class="arrowArea">
				<img src="../assets/images/rightArrow.png" class="rightArrow" @click="rightImgClick()"/>
			</div>

		</div>		
	</div>
</template>

<script>
	import {ref, computed} from 'vue'
		export default{
			 props: {
			    imgList: Array			
			  },
			data(){
				return {					
					maxClickNum: 0, //最大点击次数
					lastLeft:0,//上次滑动距离
					clickNum:0,//点击次数 					
					selectedIdx: 0,//当前选中的图片index
				    mainImgStr: null,
					
				}
			},
			mounted(){
				this.initImgSwiper();
				
			},
			methods:{
				initImgSwiper(){
					//console.log("初始化：")
					this.mainImgStr = this.imgList[this.selectedIdx];
					//console.log(JSON.stringify(this.imgList));
					
					
				},
				leftImgClick(){
					if(this.clickNum > 0){
						let width = document.querySelectorAll('.exampleImg')[this.clickNum - 1].offsetWidth;
						document.getElementsByClassName('exampleImgs')[0].style.marginLeft = `${this.lastLeft + width}px`;
						 this.lastLeft = width +  this.lastLeft;
						 this.clickNum = this.clickNum - 1;					
					}
				},
				rightImgClick(){
					if(this.clickNum < this.imgList.length - 2){
						let width = document.querySelectorAll('.exampleImg')[this.clickNum].offsetWidth;
						let lastItemOffsetLeft = document.getElementsByClassName('exampleImg')[this.imgList.length - 1].offsetLeft;
						let lookWidth = document.getElementById("exampleScroll").clientWidth;
						if(lastItemOffsetLeft > lookWidth){
							document.getElementsByClassName('exampleImgs')[0].style.marginLeft = `${this.lastLeft - width}px`;
							this.lastLeft = this.lastLeft - width;
							this.clickNum += 1;
							this.maxClickNum = this.clickNum;
						}					
					}
				},
				
				changeImg(item,index){
					this.mainImgStr = item;
					this.selectedIdx = index
				}
			}
		}
</script>

<style scoped>
	.proImg{
		width: 314px;
		height: 314px;
		border: 1px solid #e6e6e6;
	}
	
	.exampleArea{
		width: 314px;
		display: flex;
		align-items: center;
		margin-top: 15px;
	}
	
	.leftArrow,.rightArrow{
		width: 12px;
		height: 21;
		cursor: pointer;
	}
	
	#exampleScroll{
		width: 264px;
		overflow: hidden;
		display: flex;
	}
	
	.exampleImgs{
		display: flex;
	}	
	
	.exampleImg{
		width: 65px;
		min-width: 65px;
		height: 65px;
		border: 1px solid #e6e6e6;
		margin-right: 14px;
	}
	
	.arrowArea{
		width: 23px;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	
	.exampleImg.active{
		border:1px solid #0380fe;
	}
</style>